const configuration = {
  labelDotRadius: 0.8,
  labelSize: 0.0,
  labelResolution: 1,
  backgroundImageUrl: '//unpkg.com/three-globe/example/img/night-sky.png',
  globeImageUrl: '//unpkg.com/three-globe/example/img/earth-night.jpg',
  bumpImageUrl: 'https://i.postimg.cc/mgrJfkBt/bump.jpg',
};
export default configuration;
